import Loadable from 'react-loadable';

export const NoWorkspaceSearch = Loadable({
  loader: () => import(/* webpackChunkName: "NoWorkspaceSearch" */ './NoWorkspaceSearch'),
  loading: () => null,
});
